export const SET_COMPANIES_PANE_STATE = 'SET_COMPANIES_PANE_STATE';
export const SET_INVESTORS_PANE_STATE = 'SET_INVESTORS_PANE_STATE';
export const SET_SCHOOLS_PANE_STATE = 'SET_SCHOOLS_PANE_STATE';
export const SET_PEOPLE_PANE_STATE = 'SET_PEOPLE_PANE_STATE';
export const SET_PRODUCTS_PANE_STATE = 'SET_PRODUCTS_PANE_STATE';
export const SET_EVENTS_PANE_STATE = 'SET_EVENTS_PANE_STATE';
export const SET_DATAVASE_ARTICLES_PANE_STATE = 'SET_DATAVASE_ARTICLES_PANE_STATE';
